import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

// 初始化 i18n
i18n
  .use(Backend)
  .use(LanguageDetector) // 自动检测语言
  .use(initReactI18next) // 绑定 React
  .init({
    keySeparator: false,
    ns: ['translation', 'country', 'category', 'language'], // 命名空间
    defaultNS: 'translation',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // 指定 JSON 文件路径
    },
    lng: 'en',
    fallbackLng: 'en', // 默认语言
    interpolation: {
      escapeValue: false, // React 已经内置了 XSS 防护
    },
  })

export default i18n
